export type ImageFieldMode = 'upload' | 'static';

export const resolveImageFieldMode = (value?: string): ImageFieldMode => {
  const normalized = String(value || '').trim();
  if (
    normalized.startsWith('/static/') ||
    normalized.startsWith('static/')
  ) {
    return 'static';
  }
  return 'upload';
};

export const moveArrayItem = <T,>(
  items: T[],
  fromIndex: number,
  toIndex: number,
): T[] => {
  if (
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= items.length ||
    toIndex >= items.length ||
    fromIndex === toIndex
  ) {
    return items;
  }

  const next = [...items];
  const [item] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, item);
  return next;
};
